import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Switch } from '@headlessui/react';
import PropTypes from 'prop-types';
import { memo } from 'react';
const ToggleControl = ({ label, checked, onChange, }) => {
    return (_jsxs(Switch, { checked: checked, onChange: onChange, className: `${checked ? 'bg-[#007BFF]' : 'bg-neutral-200'} overflow-hidden relative inline-flex h-6 w-11 border border-neutral-600 shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`, children: [_jsx("div", { "aria-hidden": "true", className: `${checked ? 'translate-x-5' : 'translate-x-0'} absolute -top-px -left-px pointer-events-none flex items-center justify-center h-6 w-6 transform rounded-full border border-neutral-600 bg-white shadow-lg ring-0 transition duration-200 ease-in-out` }), _jsx("span", { className: "sr-only", children: label })] }));
};
ToggleControl.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
};
export default memo(ToggleControl);
